import React, { Component } from "react";
import PropTypes from "prop-types";
import HistoryEntry from "./HistoryEntry.js";
import LoadingIndicator from "./LoadingIndicator.js";
import "./HistoryView.css";
import { getHistoryAncestors, getAllHistoryNodesSortedByTimestamp } from "../history.js";
import HistoryNode from "../HistoryNode.js";
import { ReactComponent as NewDocumentIcon } from "../icons/small-n-flat/document-new-16px-importable.svg";
import { List } from "immutable";

class HistoryView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isSidebarOpen: true, // Initially open
		};

		this.currentEntryRef = React.createRef();
		this.selfRef = React.createRef();
	}

	componentDidMount() {
		this.scrollSelectedEntryIntoView();
	}

	componentDidUpdate(prevProps) {
		if (this.props.undos.size !== prevProps.undos.size) {
			this.scrollSelectedEntryIntoView();
		}
	}

	scrollSelectedEntryIntoView() {
		const entryComponent = this.currentEntryRef.current;
		const entryEl = entryComponent && entryComponent.entryRef.current;
		if (entryEl) {
			entryEl.scrollIntoView({
				behavior: "instant",
				block: "nearest",
				inline: "nearest",
			});
		}
	}

	shouldComponentUpdate(nextProps) {
		return (
			nextProps.currentHistoryNode !== this.props.currentHistoryNode ||
			nextProps.thumbnailsByOperation !== this.props.thumbnailsByOperation ||
			nextProps.loaded !== this.props.loaded
		);
	}

	toggleSidebar = () => {
		this.setState((prevState) => ({
			isSidebarOpen: !prevState.isSidebarOpen,
		}));
	};

	render() {
		const { currentHistoryNode, goToHistoryNode, thumbnailsByOperation, loaded } = this.props;
		const { isSidebarOpen } = this.state;

		const historyAncestors = getHistoryAncestors(currentHistoryNode);
		const allHistoryNodes = getAllHistoryNodesSortedByTimestamp(currentHistoryNode);

		const navigate = (offset) => {
			const startIndex = allHistoryNodes.indexOf(currentHistoryNode);
			const newIndex = startIndex + offset;
			const newHistoryNode = allHistoryNodes[newIndex];
			if (newHistoryNode) {
				goToHistoryNode(newHistoryNode);
			}
		};

		return (
			<div className={`HistoryView ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
				<button onClick={this.toggleSidebar} className="sidebar-toggle">
					{isSidebarOpen ? 'Close Sidebar' : 'Open Sidebar'}
				</button>

				{loaded ? allHistoryNodes.map((node) => {
					const ancestorOfCurrent = historyAncestors.indexOf(node) > -1;
					const current = node === currentHistoryNode;
					return (
						<HistoryEntry
							key={node.id}
							historyNode={node}
							current={current}
							ref={current && this.currentEntryRef}
							ancestorOfCurrent={ancestorOfCurrent}
							onClick={() => goToHistoryNode(node)}
							thumbnailsByOperation={thumbnailsByOperation}
							getIconReactElementMaybe={() =>
								node.name === "New Document" ? <NewDocumentIcon width={16} height={16} /> : null
							}
						/>
					);
				}) : <LoadingIndicator />}
			</div>
		);
	}
}

HistoryView.propTypes = {
	currentHistoryNode: PropTypes.instanceOf(HistoryNode).isRequired,
	undos: PropTypes.instanceOf(List).isRequired,
	redos: PropTypes.instanceOf(List).isRequired,
	thumbnailsByOperation: PropTypes.instanceOf(Map).isRequired,
	goToHistoryNode: PropTypes.func.isRequired,
	loaded: PropTypes.bool.isRequired,
};

export default HistoryView;
